import styled from 'styled-components'
import { AccommodationPackageOptionTileGrid } from './AccommodationSameRoomOptionTile'

/**
 * This is designed to accommodate one AccommodationSameRoomOptionTile,
 * optionally with a MessageBanner above it.
 *
 * With or without the banner, AccommodationSameRoomOptionTile will be on the second grid row.
 */
export const AccommodationSameRoomOptionTileSubgrid = styled.div`
  display: grid;

  @supports (grid-template-rows: subgrid) {
    grid-row: span 2;
    grid-template-rows: subgrid;

    & > ${AccommodationPackageOptionTileGrid} {
      grid-row: 2;
    }
  }
`
